import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { WebrtcState } from 'sdk';

import { useSDK } from '../../../app';
import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { useTheme } from '../../../theme/useTheme';
import { VideoIcon } from '../../videoIcon';

const messages = defineMessages({
	videoNotEnabled: {
		id: 'header.videoIcon.notEnabled',
		defaultMessage: 'Видеозвонок недоступен',
	},
});

export const Component = observer(({ className = '' }: { className: string }) => {
	const rootStore = useSDK();
	const { conversationsStore, videoCallsStore } = rootStore;
	const { formatMessage } = useIntl();
	const theme = useTheme() as Theme;

	const call = useCallback(async () => {
		if (conversationsStore.isLatestConversationResolved) {
			await rootStore.startNewVideoConversation();
			if (!rootStore.startNewConversationRequestStatus.isLoaded) {
				return;
			}
		}
		videoCallsStore.createOffer();
	}, [rootStore, conversationsStore, videoCallsStore]);

	return (
		<div title={videoCallsStore.isVideoCallsEnabled ? '' : formatMessage(messages.videoNotEnabled)}>
			<VideoIcon
				disabled={videoCallsStore.state !== WebrtcState.off || !videoCallsStore.isVideoCallsEnabled}
				className={className}
				fill={theme.videoCalls.icons.startVideocallIcon.fill}
				onClick={call}
			/>
		</div>
	);
});

export const ChatHeaderVideoIcon = styled(Component)(
	({ theme }: { theme: Theme }) => {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { width, height, fill, ...rest } = theme.videoCalls.icons.startVideocallIcon;
		return rest;
	},
	({ theme, withMarginRight }: { withMarginRight?: boolean; theme: Theme }) => {
		const { height, width } = theme.videoCalls.icons.startVideocallIcon;
		return css`
			height: ${height};
			width: ${width};
			margin-right: ${withMarginRight ? '10px' : 'auto'};
			cursor: pointer;
		`;
	}
);
